import { Spinner } from "react-bootstrap";
import i18next from 'i18next';
import { ReactNode } from "react";

interface SpinnerButtonProps {
    label?: string | ReactNode;
    busy?: boolean;
    loadingText?: string;
}

const SpinnerButton = ({ label = i18next.t("submit"), busy = false, loadingText }: SpinnerButtonProps) => {
    return (
        <span>
            {busy ? (
                <>
                    <Spinner animation="border" size="sm" className="me-1"/>
                    {loadingText ? <span>{loadingText}</span> : ""}
                </>
            ) : (
                label
            )}
        </span>
    );
}

export default SpinnerButton;